import { BriefcaseFill, EnvelopeFill, Github, Linkedin } from "react-bootstrap-icons";

const LINKS = [
  { label: "GitHub", href: "https://github.com/khushi-tulsiyan", Icon: Github, external: true },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/khushi-tulsiyan/", Icon: Linkedin, external: true },
  { label: "Email", href: "mailto:khushitulsiyan495@gmail.com", Icon: EnvelopeFill },
  { label: "Fiverr", href: "https://www.fiverr.com/s/99G091d", Icon: BriefcaseFill, external: true },
];

export const SocialLinks = ({ className = "" }) => (
  <ul className={`social-links ${className}`}>
    {LINKS.map(({ label, href, Icon, external }) => (
      <li key={label}>
        <a href={href} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
          <Icon size={16} aria-hidden="true" />
          {label}
        </a>
      </li>
    ))}
  </ul>
);
